const tabsList = [{
  title: '沪深A股',
  name: 'aStock',
  index: 0,
},{
  title: '港股',
  name: 'hkStock',
  index: 1,
},{
  title: '京市A股',
  name: 'newStock',
  index: 2,
}]

const tabsListAStock = [{
  title: '待申购',
  name: 'willBuy',
  index: 0,
  maidian: 'free_ipo.agu.jjsg'
},{
  title: '可申购',
  name: 'todayBuy',
  index: 1,
  maidian: 'free_ipo.agu.jrsg'
},{
  title: '待上市',
  name: 'willPerformance',
  index: 2,
  maidian: 'free_ipo.agu.dss'
},{
  title: '已上市',
  name: 'listedPerformance',
  index: 3,
  maidian: 'free_ipo.agu.ssbx'
}]

const tabsListListed = [{
  title: '新股',
  name: 'stock',
  index: 0,
  maidian: 'xg'
},{
  title: '新债',
  name: 'bond',
  index: 1,
  maidian: 'xz'
}]

const tabsListPlate = [
  {
    title: '待申购',
    name: 'willBuy',
    index: 0,
    maidian: 'free_ipo.bjs.jjsg'
  },{
    title: '可申购',
    name: 'todayBuy',
    index: 1,
    maidian: 'free_ipo.bjs.jrsg'
  },{
    title: '待上市',
    name: 'willPerformance',
    index: 2,
    maidian: 'free_ipo.bjs.dss'
  },{
    title: '已上市',
    name: 'listedPerformance',
    index: 3,
    maidian: 'free_ipo.bjs.ssbx'
  },
]

const willListedConfig = {
  name: '待上市',
  hasSelect: true,
  isSegment: false,
  noDataConfig: {
    name: '',
    nameStock: '',
    text: '暂无待上市新股',
    textBond: '暂无待上市新债',
    showBondSelect: false,
  }
}

const listedConfig = {
  name: '已上市',
  hasSelect: true,
  isSegment: false,
  noDataConfig: {
    name: '',
    nameStock: '',
    text: '暂无数据',
    textBond: '暂无数据',
    showBondSelect: false,
  }
}

const newPlatewillConfig = {
  name: '待上市',
  hasSelect: false,
  isSegment: false,
  noDataConfig: {
    name: '',
    nameStock: '',
    text: '暂无待上市新股',
    showBondSelect: false,
  }
}

const newPlateListedConfig = {
  name: '已上市',
  hasSelect: false,
  isSegment: false,
  noDataConfig: {
    name: '',
    nameStock: '',
    text: '暂无数据',
    showBondSelect: false,
  }
}


export {
  tabsList,
  tabsListAStock,
  tabsListListed,
  willListedConfig,
  listedConfig,
  tabsListPlate,
  newPlatewillConfig,
  newPlateListedConfig,
};